import { render, staticRenderFns } from "./DeptExtensionInfo.vue?vue&type=template&id=cdea96ee&scoped=true"
import script from "./DeptExtensionInfo.vue?vue&type=script&lang=js"
export * from "./DeptExtensionInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptExtensionInfo.vue?vue&type=style&index=0&id=cdea96ee&prod&scoped=true&less=true&lang=css"
import style1 from "./DeptExtensionInfo.vue?vue&type=style&index=1&id=cdea96ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdea96ee",
  null
  
)

export default component.exports